var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { mapProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchBoost, fetchBoostCollections, fetchBoostPages } from './api';
export class BoostSearchProvider {
    constructor() {
        this.accumulatedProducts = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
        this.collections = {
            collections: [],
            total: 0,
        };
        this.pages = {
            pages: [],
            total: 0,
        };
        this.setting = {
            showFilterCount: true,
            showTotalProductCount: true,
            showSearchBar: false,
            showGridOptions: true,
            reverseRangeSlider: true,
        };
        this.lastSearchParams = null;
        this.scrollPosition = 0;
    }
    hasSearchParamsChanged(query, options, collectionHandle, currentPage) {
        if (!this.lastSearchParams)
            return true;
        const currentFilters = options.filters || {};
        const lastFilters = this.lastSearchParams.filters || {};
        if (query !== this.lastSearchParams.query ||
            options.sort !== this.lastSearchParams.sort ||
            collectionHandle !== this.lastSearchParams.collectionHandle ||
            currentPage !== this.lastSearchParams.currentPage) {
            return true;
        }
        const currentFilterKeys = Object.keys(currentFilters);
        const lastFilterKeys = Object.keys(lastFilters);
        if (currentFilterKeys.length !== lastFilterKeys.length) {
            return true;
        }
        for (const key of currentFilterKeys) {
            const currentValues = currentFilters[key] || [];
            const lastValues = lastFilters[key] || [];
            if (currentValues.length !== lastValues.length) {
                return true;
            }
            for (const value of currentValues) {
                if (!lastValues.includes(value)) {
                    return true;
                }
            }
        }
        return false;
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            var _a;
            const { page = 1, pageSize = 24, // Use passed pageSize or default to 24
            sort = 'relevance', filters, } = options;
            const searchApp = document.querySelector('#search-app');
            const urlParams = new URLSearchParams(window.location.search);
            const pathname = window.location.pathname;
            let currentPage = 'collection_page';
            let collectionHandle = undefined;
            if (pathname.includes('/search') || urlParams.has('q')) {
                currentPage = 'search_page';
            }
            else {
                currentPage = 'collection_page';
            }
            if (searchApp.dataset.collectionId) {
                collectionHandle = searchApp.dataset.collectionId || '*';
            }
            if (currentPage === 'search_page') {
                this.setting.showGridOptions = false;
                this.setting.showTotalProductCount = false;
            }
            const currentPageNumber = page;
            const searchParamsChanged = this.hasSearchParamsChanged(query, options, collectionHandle, currentPage);
            // if (searchParamsChanged && currentPageNumber === 1) {
            //   this.scrollPosition = window.scrollY;
            // }
            if (searchParamsChanged ||
                currentPageNumber === 1 ||
                this.accumulatedProducts.length === 0) {
                this.accumulatedProducts = [];
                this.lastSearchParams = {
                    query,
                    sort: options.sort,
                    filters: options.filters ? Object.assign({}, options.filters) : undefined,
                    collectionHandle,
                    currentPage,
                };
            }
            try {
                // Format price filter if it exists
                const formattedFilters = filters ? Object.assign({}, filters) : undefined;
                if (formattedFilters === null || formattedFilters === void 0 ? void 0 : formattedFilters.pf_p_price) {
                    // Ensure price filter is in the correct format (min:max)
                    formattedFilters.pf_p_price = formattedFilters.pf_p_price.map((value) => {
                        if (value.includes(':'))
                            return value;
                        return value.replace(',', ':');
                    });
                }
                const pagePromises = [];
                if (this.accumulatedProducts.length > 0 &&
                    !searchParamsChanged &&
                    currentPageNumber > 1) {
                    pagePromises.push(fetchBoost({
                        q: query,
                        page: currentPageNumber,
                        pageSize,
                        sort,
                        filters: formattedFilters,
                        pg: currentPage,
                        collectionHandle,
                    }));
                }
                else {
                    for (let i = 1; i <= currentPageNumber; i++) {
                        pagePromises.push(fetchBoost({
                            q: query,
                            page: i,
                            pageSize,
                            sort,
                            filters: formattedFilters,
                            pg: currentPage,
                            collectionHandle,
                        }));
                    }
                }
                const results = yield Promise.all(pagePromises);
                const lastResponse = results[results.length - 1];
                results.forEach((data) => {
                    const newProducts = mapProducts(data.products);
                    const existingIds = new Set(this.accumulatedProducts.map((p) => p.id));
                    const uniqueNewProducts = newProducts.filter((p) => !existingIds.has(p.id));
                    this.accumulatedProducts = [
                        ...this.accumulatedProducts,
                        ...uniqueNewProducts,
                    ];
                });
                if (currentPage === 'search_page') {
                    // Make collections and pages requests in parallel
                    const [collectionsData, pagesData] = yield Promise.all([
                        fetchBoostCollections({
                            q: query,
                            page: currentPageNumber,
                            pageSize,
                            pg: 'search_page',
                            sort,
                        }),
                        fetchBoostPages({
                            q: query,
                            page: currentPageNumber,
                            pageSize,
                            pg: 'search_page',
                            sort,
                        }),
                    ]);
                    this.collections = {
                        collections: collectionsData.collections,
                        total: collectionsData.total_collection,
                    };
                    this.pages = {
                        pages: pagesData.pages,
                        total: pagesData.total_page,
                    };
                }
                this.filters = mapFilters(lastResponse.filter, formattedFilters);
                this.meta = mapMeta(lastResponse, currentPageNumber, pageSize);
                this.sortOptions = mapSorts();
                // Update the search count element if it exists on search page
                const searchCountEl = document.querySelector('.search-count');
                if (searchCountEl) {
                    searchCountEl.innerText =
                        lastResponse.total_product !== undefined
                            ? lastResponse.total_product.toString()
                            : '0';
                }
                const gridOptions = [
                    { id: 'gridOne', text: 'Grid One' },
                    { id: 'gridTwo', text: 'Grid Two' },
                    { id: 'gridFour', text: 'Grid Multi' },
                    { id: 'list', text: 'List' },
                ];
                const boostWidgetIntegration = window === null || window === void 0 ? void 0 : window.boostWidgetIntegration;
                const boostBlocks = boostWidgetIntegration === null || boostWidgetIntegration === void 0 ? void 0 : boostWidgetIntegration.blocks;
                const boostBisBlock = boostBlocks === null || boostBlocks === void 0 ? void 0 : boostBlocks['bc-bis'];
                const boostApp = boostBisBlock === null || boostBisBlock === void 0 ? void 0 : boostBisBlock.app;
                const boostFilterSettings = boostApp === null || boostApp === void 0 ? void 0 : boostApp.filterSettings;
                if (boostFilterSettings) {
                    this.setting.showFilterCount =
                        (_a = boostFilterSettings.showFilterOptionCount) !== null && _a !== void 0 ? _a : true;
                }
                this.setting = Object.assign(Object.assign({}, this.setting), { totalProductCount: lastResponse.total_product || 0, gridOptions,
                    currentPage });
                if (searchParamsChanged &&
                    currentPageNumber === 1 &&
                    this.scrollPosition > 0) {
                    requestAnimationFrame(() => {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                        });
                    });
                }
            }
            catch (error) {
                throw new Error('Failed to load data from Boost API');
            }
        });
    }
    getProducts() {
        return this.accumulatedProducts;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
    getSetting() {
        return this.setting;
    }
    getCollections() {
        return this.collections;
    }
    getPages() {
        return this.pages;
    }
}
